import { useSite } from "../SiteProvider";
const useRepeatableRepeater = ({ type, repeatableId, repeatableItemId, identifier, }) => {
    const { repeatables } = useSite();
    if (!type || !repeatableId || !repeatableItemId) {
        return {
            value: "type, repeatableId, or repeatableItemId not found",
        };
    }
    const repeatableRepeater = repeatables.find((r) => r.id === repeatableId);
    const repeatableRepeaterItem = repeatableRepeater?.items.find((i) => i.id === repeatableItemId);
    if (repeatableRepeaterItem) {
        if (identifier === "repeatable_name") {
            return {
                value: repeatableRepeaterItem?.name,
            };
        }
        const repeatableRepeaterField = repeatableRepeater.fields?.find((f) => f.identifier === identifier);
        const repeaterFieldValue = repeatableRepeaterItem.values?.find((v) => v.field_id === repeatableRepeaterField?.id);
        if (type === "image") {
            return {
                value: repeaterFieldValue?.value
                    ? JSON.parse(repeaterFieldValue?.value).src
                    : null,
            };
        }
        return {
            value: repeaterFieldValue?.value,
        };
    }
    return {
        value: null,
    };
};
export default useRepeatableRepeater;
//# sourceMappingURL=useRepeatableRepeaterFieldProps.js.map